import { Breadcrumb, Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

const ReportLayout = () => {
  return (
    <Container>
      <Breadcrumb>
        <Breadcrumb.Item active>Reporte</Breadcrumb.Item>
      </Breadcrumb>
      <Outlet />
    </Container>
  );
};

export default ReportLayout;
